module.exports = __webpack_public_path__ + "b91b646d15a511f15133837ec04e5bb2.png";